import React, { lazy, Suspense } from 'react';
import { render } from "react-dom";

const Establishments = lazy(() => import(/* webpackChunkName: "Establishments" */ './components/Establishments'));

const establishments = Array.from(document.querySelectorAll(".extranet-establishments"));
if (establishments != null) {
    establishments.forEach(establishment => {
        const updateUrl =
            typeof establishment.dataset.updateUrl !== "undefined" ? establishment.dataset.updateUrl : "";

        const workshopHost =
            typeof establishment.dataset.workshopHost !== "undefined" ? establishment.dataset.workshopHost : "";

        const esteblishmentsData =
            typeof establishment.dataset.establishments !== "undefined" ? JSON.parse(establishment.dataset.establishments) : [];

        const usps =
            typeof establishment.dataset.usps !== "undefined" ? JSON.parse(establishment.dataset.usps) : [];

        render(
            <Suspense fallback={<></>}>
                <Establishments establishments={esteblishmentsData} updateUrl={updateUrl} usps={usps} workshopHost={workshopHost} />
            </Suspense>,
            establishment
        );
    });
}
